// src/pages/GradesPage/components/SubjectsView.jsx
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faSearch,
	faSpinner,
	faExclamationTriangle,
	faBookOpen,
} from "@fortawesome/free-solid-svg-icons";
import GradesTable from "./GradesTable";
import EmptyState from "./EmptyState";
import { calculateSemesterTotal, getSemesterMonths } from "../utils";
import styles from "../GradesPage.module.css";

const SubjectsView = ({
	selectedSubject,
	selectedSemester,
	searchTerm,
	setSearchTerm,
	students,
	grades,
	classData,
	departmentId,
	isLoadingGrades,
	gradesError,
	onGradeCellClick,
}) => {
	if (!selectedSubject) {
		return (
			<EmptyState
				icon={faBookOpen}
				title="Select a Subject"
				message="Choose a subject from the sidebar to view and manage student grades"
			/>
		);
	}

	const calculateTotal = (studentId) =>
		calculateSemesterTotal(grades, studentId, selectedSemester);

	const handleGradeCellClick = (studentId, month) => {
		// Find student info
		const student = students.find((s) => s.id === studentId);

		// Find month info
		const monthData = getSemesterMonths(selectedSemester).find(
			(m) => m.id === month
		);

		// Only allow clicking if teacher is assigned to this subject
		if (!selectedSubject.teacherAssigned) {
			return;
		}

		// Call the parent handler with all required data
		onGradeCellClick(
			studentId,
			student?.name || "Unknown Student",
			selectedSubject.id,
			selectedSubject.name,
			month,
			monthData?.name || "Unknown Month",
			departmentId
		);
	};

	return (
		<>
			<div className={styles.contentHeader}>
				<div className={styles.contentTitle}>
					<h2>
						{selectedSubject.name} - {selectedSubject.class}
					</h2>
					<span className={styles.semesterLabel}>
						{selectedSemester === 1 ? "1st" : "2nd"} Semester
					</span>
				</div>
				<div className={styles.searchContainer}>
					<FontAwesomeIcon icon={faSearch} className={styles.searchIcon} />
					<input
						type="text"
						placeholder="Search students..."
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						className={styles.searchInput}
					/>
				</div>
			</div>

			{!selectedSubject.teacherAssigned && (
				<div className={styles.notAssignedWarning}>
					<FontAwesomeIcon icon={faExclamationTriangle} />
					<span>You are not assigned to this subject (View Only)</span>
				</div>
			)}

			{isLoadingGrades ? (
				<div className={styles.loadingContainer}>
					<FontAwesomeIcon icon={faSpinner} className={styles.spinner} spin />
					<p>Loading grades...</p>
				</div>
			) : gradesError ? (
				<div className={styles.errorContainer}>
					<FontAwesomeIcon
						icon={faExclamationTriangle}
						className={styles.errorIcon}
					/>
					<p>Error loading grades. Please try again.</p>
				</div>
			) : (
				<GradesTable
					students={students}
					selectedSemester={selectedSemester}
					grades={grades}
					classGradeLevel={classData.gradeLevel}
					isEditable={selectedSubject.teacherAssigned}
					onGradeCellClick={handleGradeCellClick}
					calculateTotal={calculateTotal}
				/>
			)}
		</>
	);
};

export default SubjectsView;
